export { SimilarProductsSection } from './SimilarProductsSection';
